import React from "react";

const RefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Refund & Warranty Policy</h1>

      <p>
        Ora Bike has been committed to delivering reliable and eco-friendly electric vehicles since 2022. We strive to ensure customer satisfaction through quality products and dependable support. Please review our refund and warranty policy below.
      </p>

      <h2>1. Battery & Controller Warranty</h2>
      <ul>
        <li>All Ora Bike models come with a <strong>14-month warranty and guarantee</strong> on the battery.</li>
        <li>The controller is covered under a <strong>12-month guarantee</strong> from the date of purchase.</li>
        <li>Warranty covers manufacturing defects only and does not apply to damage caused by misuse, accidents, or unauthorized repairs.</li>
      </ul>

      <h2>2. Service & Complaint Handling</h2>
      <p>
        Customers can register complaints and service requests via:
      </p>
      <ul>
        <li>Our official service centers available in most districts across India.</li>
        <li>Directly through company-appointed engineers or our support portal.</li>
      </ul>
      <p>
        Timely service is a core part of our commitment, and we aim to resolve issues quickly and efficiently.
      </p>

      <h2>3. Refund Eligibility</h2>
      <p>
        Refunds may be considered only under exceptional circumstances such as:
      </p>
      <ul>
        <li>Major manufacturing defects identified within 7 days of delivery.</li>
        <li>Product delivered does not match the order specifications.</li>
        <li>The product remains unused and is in its original condition.</li>
      </ul>
      <p>
        Refunds are processed only after inspection and approval from the service team.
      </p>

      <h2>4. Items Not Eligible for Refund</h2>
      <ul>
        <li>Used or modified vehicles.</li>
        <li>Battery or controller issues after the warranty period.</li>
        <li>Products damaged due to external factors like water damage, tampering, or overloading.</li>
      </ul>

      <h2>5. Requesting a Refund or Exchange</h2>
      <p>
        To request a refund or product inspection, please:
      </p>
      <ul>
        <li>Contact our support team at <strong>info@orabike.in</strong> with invoice and issue details.</li>
        <li>Attach photos or videos highlighting the issue clearly.</li>
        <li>Wait for a confirmation and instructions from our technical team.</li>
      </ul>

      <h2>6. Processing Time</h2>
      <p>
        After receiving and verifying the returned vehicle/component, refunds (if approved) will be processed within 7–10 working days to the original payment method.
      </p>

      <h2>7. Shipping & Transport Costs</h2>
      <p>
        The customer is responsible for transportation or shipping costs of returns unless the return is due to an error from our side (e.g., wrong item or manufacturing defect).
      </p>

      <h2>8. Contact Support</h2>
      <p>
        For warranty claims, complaints, or refund-related assistance, please contact:
        <br />
        <strong>info@orabike.in</strong>
        <br />
       +91-2269711724 (Mon–Sat, 10 AM – 6 PM)
      </p>
    </div>
  );
};

export default RefundPolicy;
